import { createFileRoute } from '@tanstack/react-router';

import { BrandReviewDetailView } from 'src/sections/brand-review/brand-review-detail-view';

export const Route = createFileRoute('/w/brand-reviews/$reviewId')({
  component: StaffBrandReviewPage,
});

function StaffBrandReviewPage() {
  const { reviewId } = Route.useParams();
  return <BrandReviewDetailView reviewId={reviewId} />;
}
